import {
  UploadFileExtensionsEnum,
  UploadFileTypeEnum,
  CommonInventoryType,
} from '@dynamika-shared/types/inventory';

type DetectFileExtensions = {
  fileType: UploadFileTypeEnum | null;
};

export const detectFileExtensions = ({ fileType }: DetectFileExtensions) => {
  switch (fileType) {
    case UploadFileTypeEnum.DXA:
    case UploadFileTypeEnum.DICOM:
    case UploadFileTypeEnum.MISC:
    case UploadFileTypeEnum.HRPQCT:
    case UploadFileTypeEnum.MEDIA:
      return UploadFileExtensionsEnum.ZIP;
    case UploadFileTypeEnum.DICOMIZED_PDF:
      return UploadFileExtensionsEnum.PDF;
    case UploadFileTypeEnum.DICOMIZED_CSV:
      return UploadFileExtensionsEnum.CSV;
    default:
      return undefined;
  }
};
export const getFileContentType = ({ fileType }: DetectFileExtensions) => {
  switch (fileType) {
    case UploadFileTypeEnum.DXA:
    case UploadFileTypeEnum.DICOM:
    case UploadFileTypeEnum.MISC:
    case UploadFileTypeEnum.HRPQCT:
    case UploadFileTypeEnum.MEDIA:
      return 'application/zip';
    case UploadFileTypeEnum.DICOMIZED_PDF:
      return 'application/pdf';
    case UploadFileTypeEnum.DICOMIZED_CSV:
      return 'text/csv';
    default:
      return undefined;
  }
};

export const validFileTypes: Record<
  UploadFileExtensionsEnum,
  UploadFileTypeEnum[]
> = {
  [UploadFileExtensionsEnum.ZIP]: [
    UploadFileTypeEnum.DICOM,
    UploadFileTypeEnum.DXA,
    UploadFileTypeEnum.MISC,
    UploadFileTypeEnum.HRPQCT,
    UploadFileTypeEnum.MEDIA,
  ],
  [UploadFileExtensionsEnum.PDF]: [UploadFileTypeEnum.DICOMIZED_PDF],
  [UploadFileExtensionsEnum.CSV]: [UploadFileTypeEnum.DICOMIZED_CSV],
};

const supportedFilesMap = new Map(
  Object.values(UploadFileTypeEnum).map((file, index) => [file, index])
);
export const fileTypeConfig = (labels?: CommonInventoryType[]) => {
  if (!labels?.length) {
    return [];
  }
  return [
    ...new Set(
      labels
        .map(({ inputDataType }) => inputDataType)
        .sort((a, b) => {
          const indexA = supportedFilesMap.get(a) ?? Infinity;
          const indexB = supportedFilesMap.get(b) ?? Infinity;

          return indexA - indexB;
        })
    ),
  ];
};
 